module.exports = __webpack_public_path__ + "img/intro-cv-image-it.e9df4df0.png";